export class AddTask {
    ID:number;
    CLIENT_ID:number;

DAILY_TASK_MASTER_ID
TASK:any
STATUS:string;
PRIORITY:string
TAKEN_DATE:any
COMPLETED_DATE:any
COMPLETION_PERCENTAGE:number
REMARK:any


}